/*
    🔥 MATEMÁTICA DEL CALENDARIO

    ⚠️ SIN LIBRERÍA DE FECHAS

    Date alcanza para una grilla de mes. date-fns ya está en el
    proyecto: si necesitás formateo con locale usalo en la VISTA, pero
    la grilla no debería depender de eso.

    ⚠️ LA SEMANA NO EMPIEZA EL DOMINGO EN TODOS LADOS

    getDay() devuelve 0 para domingo. En Argentina y casi toda Europa
    la semana arranca el lunes. weekStart lo resuelve sin tocar el
    resto.

    ⚠️ SIEMPRE 42 CELDAS

    Seis semanas fijas. Si la grilla midiera 28, 35 o 42 según el mes,
    el calendario cambiaría de alto al navegar y el contenido de abajo
    saltaría en cada clic.
*/

export const WEEKDAYS_ES = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

export const MONTHS_ES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

// 🔥 Clave estable AAAA-MM-DD en hora LOCAL. toISOString() usaría UTC
//    y en Argentina (UTC-3) correría los eventos un día para atrás.
export const onDateKey = (date) => {
    const Y = date.getFullYear();
    const M = String(date.getMonth() + 1).padStart(2, '0');
    const D = String(date.getDate()).padStart(2, '0');
    return `${Y}-${M}-${D}`;
};

export const onIsSameDay = (a, b) => (
    a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate()
);

/*
    🔥 Devuelve las 42 celdas del mes

    weekStart: 1 = lunes (default) | 0 = domingo
*/
export const onBuildMonthGrid = (year, month, weekStart = 1) => {

    const FIRST = new Date(year, month, 1);

    // Cuántos días del mes anterior hay que mostrar antes del día 1
    const OFFSET = (FIRST.getDay() - weekStart + 7) % 7;

    const START = new Date(year, month, 1 - OFFSET);

    return Array.from({ length: 42 }, (_, i) => {

        const DATE = new Date(START.getFullYear(), START.getMonth(), START.getDate() + i);

        return {
            date: DATE, key: onDateKey(DATE), day: DATE.getDate(),
            isOutside: DATE.getMonth() !== month, isWeekend: DATE.getDay() === 0 || DATE.getDay() === 6,
        };
    });
};

export const onShiftMonth = (year, month, delta) => {
    const D = new Date(year, month + delta, 1);
    return { year: D.getFullYear(), month: D.getMonth() };
};

/*
    🔥 Agrupa los eventos por día

    Recibe [{ id, date: Date|string, title, tone }] y devuelve
    { '2026-03-12': [evento, evento], … }
*/
export const onGroupByDay = (events = []) => events.reduce((acc, event) => {

    const DATE = event.date instanceof Date ? event.date : new Date(event.date);

    if (Number.isNaN(DATE.getTime())) return acc;

    const KEY = onDateKey(DATE);

    acc[KEY] = acc[KEY] ?? [];
    acc[KEY].push({ ...event, date: DATE });

    return acc;
}, {});
